var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-income-svgrepo-com (2) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.1862 2.83464C21.7957 2.44412 21.1625 2.44412 20.772 2.83464L4.5 19.1066V12.5001C4.5 11.9478 4.05228 11.5001 3.5 11.5001C2.94772 11.5001 2.5 11.9478 2.5 12.5001V20.5001C2.5 21.6047 3.39543 22.5001 4.5 22.5001H12.5C13.0523 22.5001 13.5 22.0524 13.5 21.5001C13.5 20.9478 13.0523 20.5001 12.5 20.5001H5.93498L22.1862 4.24885C22.5767 3.85833 22.5767 3.22517 22.1862 2.83464Z",
    fill: "#304FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncome);
export default __webpack_public_path__ + "static/media/income.e65c47045acb096c88f5dab58728cc91.svg";
export { ForwardRef as ReactComponent };